module.exports = __webpack_public_path__ + "static/media/ecobank.afa15a1e.svg";